module.exports = __webpack_public_path__ + "img/login-qrcode.814b1353.png";